// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"8004191b","787":"e527da32"}[chunkId] + ".chunk.js";
};